<div class="message">
    {{ generalPracticalModuleLog.message }}
</div>
<div *ngIf="generalPracticalModuleLog.data">
    <ngx-json-viewer
        [json]="generalPracticalModuleLog.data"
    ></ngx-json-viewer>
</div>